// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"5ea1df90","442":"f3660fe0"}[chunkId] + ".chunk.js";
};